import { PayeeStoreState } from "@/employer/types";
import { FetchState, HsabPayee } from "@/shared/types";
import { defineStore } from "pinia";
import * as payeeService from "@/shared/api/payeeService";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";

export const initialState: PayeeStoreState = {
    payeesForUser: [],
    fetchState: FetchState.Uninitialized,
    createState: FetchState.Uninitialized,
    saveState: FetchState.Uninitialized,
    deleteState: FetchState.Uninitialized
};

export const usePayeeStore = defineStore("payee", {
    state: () => (_.cloneDeep(initialState)),
    getters: {
        isFetchingLoading: state => state.fetchState === FetchState.Loading,
        isCreateLoading: state => state.createState === FetchState.Loading,
        isSaveLoading: state => state.saveState === FetchState.Loading,
        isDeleteLoading: state => state.deleteState === FetchState.Loading,
    },
    actions: {
        LoadPayees () {
            if (this.fetchState === FetchState.Loading) {
                return;
            }

            this.fetchState = FetchState.Loading;
            return payeeService.getPayees()
                .then(response => {
                    this.payeesForUser = response.data;
                    this.fetchState = FetchState.Loaded;
                }).catch(err => {
                    storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        createPayee (p: HsabPayee) {
            if (this.createState === FetchState.Loading) {
                return;
            }

            this.createState = FetchState.Loading;
            return payeeService.createPayee(p)
                .then(response => {
                    this.payeesForUser.push(response.data);
                    this.createState = FetchState.Uninitialized;
                    return response.data;
                }).catch(err => {
                    storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        savePayee (p: HsabPayee) {
            if (this.saveState === FetchState.Loading) {
                return;
            }

            this.saveState = FetchState.Loading;
            return payeeService.updatePayee(p)
                .then(response => {
                    _.remove(this.payeesForUser, (x: HsabPayee) => x.payeeId === p.payeeId);

                    this.payeesForUser.push(response.data);
                    this.saveState = FetchState.Uninitialized;
                    return response.data;
                }).catch(err => {
                    storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        deletePayee (payeeId: number) {
            if (this.deleteState === FetchState.Loading) {
                return;
            }

            this.deleteState = FetchState.Loading;
            return payeeService.deletePayee(payeeId)
                .then(response => {
                    _.remove(this.payeesForUser, (x: HsabPayee) => x.payeeId === payeeId);
                    this.deleteState = FetchState.Uninitialized;
                }).catch(err => {
                    storeHelper.handleError({ error: err, rethrow: true });
                });
        },
    }
});